import React, { useState, useContext } from 'react';
import clsx from 'clsx';
import { UserContext } from '../components/userContext';
import { Link, useHistory, useParams } from 'react-router-dom';
import axios from 'axios';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import LockRoundedIcon from '@material-ui/icons/LockRounded';
import PersonAddRoundedIcon from '@material-ui/icons/PersonAddRounded';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import VisibilityRoundedIcon from '@material-ui/icons/VisibilityRounded';
import VisibilityOffRoundedIcon from '@material-ui/icons/VisibilityOffRounded';
import { FormControl, InputLabel, OutlinedInput } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paper: {
    // marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: '#fff',
  },
  form: {
    '$ $input': {
      backgroundColor: 'none'
    },
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    '& .MuiFormLabel-root.Mui-focused': {
      color: 'rgb(163, 102, 255)',
    },
    '& .Mui-focused': {  
      '& .MuiOutlinedInput-notchedOutline': {
        border: '2px solid rgb(163, 102, 255)'
      }
    },
  },
  formControl: {
    marginTop: 16,
    marginBottom: 8,
    width: '100%',
    '& .MuiIconButton-root:hover,': {
      backgroundColor: 'transparent'
    },
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  link: {
    color: theme.palette.text.secondary,
    textDecoration: 'none'
  }
}));

export default function UserLog() {
  const classes = useStyles();
  const { setUser } = useContext(UserContext);
	const [ input, setInput ] = useState({name: '', email: '', password: '', showPassword: false});
	let history = useHistory();
  const { log } = useParams();

  const handleClickShowPassword = () => {
    setInput({ ...input, showPassword: !input.showPassword });
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleSubmit = (event) => {
		event.preventDefault();

    if (log === 'signin') {
      axios.post('https://backendexample.sanbersy.com/api/user-login', {
        email: input.email,
        password: input.password
      }).then((res) => {
        var user = res.data.user,
            token = res.data.token,
            currentUser = {name: user.name, email: user.email, password: user.password, token};
        setUser(currentUser);
        localStorage.setItem('user', JSON.stringify(currentUser));
        history.push('/');
      }).catch((err) => {
        alert(JSON.stringify(err.response.data));
        setInput({name: '', email: '', password: ''});
      });
    } 
    if (log === 'signup') {
      axios.post('https://backendexample.sanbersy.com/api/register', {
        name: input.name,
        email: input.email,
        password: input.password
      }).then(() => {
        alert(`Your account has been successfully registered \nPlease login to continue...`);
        history.push(`/user/signin`);
      }).catch((err) => {
        var errObj = (JSON.parse(err.response.data));
        var txt = '';
        for (var i = 0; i < Object.entries(errObj).length; i++) {
          txt += Object.entries(errObj)[i][1].toString() + '\n';   
        }
        alert(txt);
      });
      setInput({name: '', email: '', password: ''});
    }
  }

  const handleChange = (event) => {
		let value = event.target.value;
		let name = event.target.name;
		setInput({...input, [name]: value})
		// Long way method
		// switch (name) {
		// 	case 'email': {
		// 		setInput({...input, email: value});
		// 		break;
		// 	}
		// 	case 'password': {
		// 		setInput({...input, password: value});
		// 		break;
		// 	}
		// 	default: {break;}
		// }
		console.log(input);
	}

  return (
    <Container maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          { log === 'signin' ? <LockRoundedIcon /> : <PersonAddRoundedIcon /> }
        </Avatar>
        <Typography component="h1" variant="h5">
          { log === 'signin' ? 'Sign In' : 'Sign Up' }
        </Typography>
        <form className={classes.form} onSubmit={handleSubmit}>
          { 
            log === 'signup' ? 
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="name"
                label="Full Name"
                name="name"
                autoComplete="name"
                autoFocus
                onChange={handleChange}
                value={input.name}
              />
            :
              <></>
          }
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            onChange={handleChange}
            value={input.email}
          />
          <FormControl className={classes.formControl} variant="outlined">
            <InputLabel>Password *</InputLabel>
            <OutlinedInput
              required
              fullWidth
              name="password"
              type={input.showPassword ? 'text' : 'password'}
              id="password"
              onChange={handleChange}
              value={input.password}
              endAdornment={
                <InputAdornment position="end">
                  <IconButton
                    onClick={handleClickShowPassword}
                    onMouseDown={handleMouseDownPassword}
                    edge="end"
                  >
                    {input.showPassword ? <VisibilityRoundedIcon style={{color: 'rgba(144, 144, 144, 1)'}} /> : <VisibilityOffRoundedIcon style={{color: 'rgba(144, 144, 144, 1)'}} />}
                  </IconButton>
                </InputAdornment>
              }
              labelWidth={85}
            />
          </FormControl>
          { 
            log === 'signin' ? 
              <FormControlLabel
                control={<Checkbox value="remember" color='default'/>}
                label="Remember me"
              />
            :
              <></>
          }
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="secondary"
            className={classes.submit}
          >
            { log === 'signin' ? 'Sign In' : 'Sign Up' }
          </Button>
          <Grid container>
            { 
              log === 'signin' ?
                <>
                  <Grid item xs={12} sm>
                    <Link to='/user/signin' className={classes.link}>Forgot password?</Link>
                  </Grid>
                  <Grid item>
                    <Link to="/user/signup" className={classes.link}>Don't have an account? Sign Up</Link>
                  </Grid>
                </>
               :
                <Grid item>
                  <Link to="/user/signin" className={classes.link}>Already have an account? Sign In</Link>
                </Grid>
            }
          </Grid>
        </form>
      </div>
    </Container>
  );
}


